import { Controller, useFormContext } from 'react-hook-form'

import { CurrencyCentInput, FF2 } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

import { s } from './styles'

export const EditTransactionsInformation = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <s.WrappedPanel rounded shadowed collapsible={false} title="Edit Transactions Information">
      <s.Inner>
        <FormRow>
          <Col>
            <Controller
              name="previousCumulativeAmount"
              control={control}
              render={({ field }) => (
                <FF2
                  field={field}
                  label="Previous SAR Cumulative Amount"
                  input={(props) => <CurrencyCentInput {...props} data-qa="Previous SAR Cumulative Amount" />}
                />
              )}
            />
          </Col>
        </FormRow>
      </s.Inner>
    </s.WrappedPanel>
  )
}
